import { render } from "./TournamentScheduleSeniCreatePage.vue?vue&type=template&id=5de832b2"
import script from "./TournamentScheduleSeniCreatePage.vue?vue&type=script&lang=js"
export * from "./TournamentScheduleSeniCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__